module.exports = __webpack_public_path__ + "img/fritadeira-eletrica.1327229a.png";